import React from "react";
import ReactDOM from "react-dom";

const Modal = ({ isOpen, onClose, children, canDismiss = true }) => {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    if (canDismiss) onClose();
  };

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center bg-opacity-30 backdrop-blur-sm z-50"
      onClick={handleBackdropClick}
    >
      <div
        className="bg-white rounded-2xl shadow-lg p-6 max-w-lg w-full relative"
        onClick={e => e.stopPropagation()}
      >
        {canDismiss && (
          <button
            className="absolute top-4 right-4 text-gray-600 px-1 border border-white rounded-sm hover:border-gray-200 hover:cursor-pointer"
            onClick={onClose}
          >
            ✕
          </button>
        )}
        <div>{children}</div>
      </div>
    </div>,
    document.getElementById("modal-root"),
  );
};

export default Modal;
